import "./bottomFixedModal.scss";
import * as React from "react";
import { useEffect } from "react";

import { BottomFixedModal as BottomFixedModalShared } from "@shared/src";

export interface Props {
  isTransition?: boolean;
  isShow: boolean;
  hideModal: () => void;
  title: string;
  hasCloseButton?: boolean;
  children: React.ReactNode;
  className?: string;

  // props 추가
  fullHeight?: boolean;
  overlayBgColor?: string;
  contentStyle?: React.CSSProperties;
  closeButtonType?: "icon" | "text";
  closeButtonPosition?: "top" | "title";
  hasHeightLimit?: boolean;
  hasInnerScroll?: boolean;
}
const BottomFixedModal = ({
  isTransition = false,
  isShow,
  hideModal,
  title,
  children,
  hasCloseButton = false,
  closeButtonType = "icon",
  className,
  overlayBgColor,
  contentStyle = {},
  closeButtonPosition = "top",
  fullHeight = false,
  hasHeightLimit = false,
  hasInnerScroll = false
}: Props) => {
  // 모달이 열릴 때 배경음악 정지
  useEffect(() => {
    if (isShow) {
      window.dispatchEvent(new Event("stopBackgroundMusic"));
    }
  }, [isShow]);

  // // 닫기버튼
  // const CloseButton = () => {
  //   return (
  //     <div className="modal-close-button-wrap">
  //       <button className={`btn btn-transparent`} onClick={hideModal}>
  //         {closeButtonType === "icon" ? <i className="icon icon-close-black"></i> : "닫기"}
  //       </button>
  //     </div>
  //   );
  // };
  // return (
  //   <div
  //     className={`bottom-fixed-modal-wrap ${isShow ? "show" : ""} ${className} ${fullHeight ? "full-height" : ""}`}
  //   >
  //     <div
  //       className="overlay"
  //       onClick={() => hideModal()}
  //       style={{ background: `${overlayBgColor ? overlayBgColor : ""}` }}
  //     ></div>
  //     <div
  //       className={`bottom-fixed-modal ${isTransition ? "has-transition" : ""}
  //       ${isShow ? "do-transtion" : ""}
  //       ${hasHeightLimit ? "has-height-limit" : ""}`}
  //     >
  //       {hasCloseButton && closeButtonPosition === "top" && <CloseButton />}
  //       <div className="modal-title-wrap">
  //         {!titleHidden && (
  //           <h2 className="modal-title" style={hasCloseButton ? { paddingRight: 50 } : {}}>
  //             {title}
  //           </h2>
  //         )}
  //         {hasCloseButton && closeButtonPosition === "title" && <CloseButton />}
  //       </div>
  //       <div className="modal-content" style={contentStyle} >
  //         {children}
  //       </div>
  //     </div>
  //   </div>
  // );
  return (
    <BottomFixedModalShared
      isTransition={isTransition}
      isShow={isShow}
      hideModal={hideModal}
      title={title}
      hasCloseButton={hasCloseButton}
      children={children}
      className={`bottom-fixed-modal-wrap ${className}`}
      fullHeight={fullHeight}
      overlayBgColor={overlayBgColor}
      contentStyle={contentStyle}
      closeButtonType={closeButtonType}
      closeButtonPosition={closeButtonPosition}
      hasHeightLimit={hasHeightLimit}
      hasInnerScroll={hasInnerScroll}
    />
  );
};

export default BottomFixedModal;
